import { styled, theme } from "@theme/stitches.config"

export const FormContainer = styled("div", {
    maxWidth: 700,
    marginLeft: "auto",
    marginRight: "auto"
})

export const Wrapper = styled("div", {
    margin: "60px 0"
})

export const StyledForm = styled("form", {

})

export const InputWrapper = styled("div", {

})

export const ButtonWrapper = styled("div", {
    marginLeft: "auto",
    width: "fit-content",
    marginTop: 20
})

export const ContentWrapper = styled("div", {
    width: "fit-content",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 40
})
